'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pathToRegexp = require('path-to-regexp');

// IMPLEMENTATION
// ===================================================

var include = function include(base, routes) {
  var mappedRoutes = {
    toString: function toString() {
      return base;
    }
  };
  Object.keys(routes).forEach(function (route) {
    var url = routes[route];

    if (typeof url === "function" && route === "toString") {
      mappedRoutes.toString = function () {
        return base + routes.toString();
      };
    } else if (typeof url === "object") {
      // nested include - prefix all sub-routes with base
      mappedRoutes[route] = include(base, url);
    } else if (typeof url === "string") {
      // route - prefix with base and replace duplicate //
      mappedRoutes[route] = url.indexOf("/") === 0 ? url : [base, url].join("/").replace("//", "/");
    } else {
      // don't allow invalid routes object
      throw new TypeError("\"" + route + "\" is not valid. A routes object can only contain a string, an object or the \"toString\" method as values.");
    }
  });
  return mappedRoutes;
};

function compileWithParams(pattern, params) {
  var reversed = pathToRegexp.compile(pattern);
  return reversed(params);
}

var reverse = function reverse(pattern, params) {
  if (params === void 0) {
    params = {};
  }

  try {
    return compileWithParams(pattern, params);
  } catch (err) {
    return pattern;
  }
};
var reverseForce = function reverseForce(pattern, params) {
  if (params === void 0) {
    params = {};
  }

  try {
    return compileWithParams(pattern, params);
  } catch (err) {
    var tokens = pathToRegexp.parse(pattern);
    return tokens.filter(function (token) {
      return typeof token === "string";
    }).join("");
  }
};

exports.include = include;
exports.reverse = reverse;
exports.reverseForce = reverseForce;
